import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Profile from './pages/Profile';
import { AuthProvider } from './context/AuthContext';
import SocietyManagement from './pages/SocietyManagement';
import MemberManagement from './pages/MemberManagement';
import Dashboard from './pages/Dashboard';
import InvitationVerification from './components/InvitationVerification';
import SSOCallback from './components/SSOCallback';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Navbar />
          <Routes>
            {/* Redirect root to login */}
            <Route path="/" element={<Navigate to="/login" replace />} />

            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/sso/callback" element={<SSOCallback />} />
            <Route path="/verify-invitation" element={<InvitationVerification />} />

            {/* Protected Routes */}
            <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path="/settings" element={<PrivateRoute><Profile /></PrivateRoute>} />
            
            {/* Member Routes */}
            <Route path="/notices" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path="/maintenance" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path="/complaints" element={<PrivateRoute><Profile /></PrivateRoute>} />
            
            {/* Admin Routes */}
            <Route path="/society-management" element={<AdminRoute><SocietyManagement /></AdminRoute>} />
            <Route path="/member-management" element={<AdminRoute><MemberManagement /></AdminRoute>} />
            
            <Route 
              path="/dashboard" 
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              } 
            />

            {/* Catch all route - redirect to login */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

// PrivateRoute component
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('accessToken');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// AdminRoute component
const AdminRoute = ({ children }) => {
  const userDataString = localStorage.getItem('userData');
  const userData = userDataString ? JSON.parse(userDataString) : null;
  const isAdmin = userData?.role === 'ADMIN';
  
  if (!userData) {
    return <Navigate to="/login" replace />;
  }
  
  if (!isAdmin) {
    return <Navigate to="/profile" replace />;
  }
  
  return children;
};

export default App; 